import { ATTR_FIRST } from '@vendia/analytics-attribution'
import debug from 'debug'

const logger = debug('analytics:utm')

export type UtmParams = {
  utm_campaign?: string
  utm_source?: string
  utm_medium?: string
  utm_content?: string
  utm_term?: string
}

/**
 * Get stored UTM parameters from first-visit attribution data.
 *
 * The @vendia/analytics-attribution package stores visitor source data in localStorage
 * when users first land on the site (under the `__ref_first` key). When UTM parameters
 * are present in the landing URL, they are stored in the `data` object with the `utm_`
 * prefix stripped (e.g., utm_source -> source).
 *
 * This is useful for passing attribution data to analytics tools like Pendo
 * after the user has authenticated (when UTM params may no longer be in the URL).
 */
export function getStoredUtmParams(): UtmParams {
  try {
    const firstRefData = localStorage.getItem(ATTR_FIRST)
    logger('Raw localStorage data:', firstRefData)
    if (firstRefData) {
      const parsed = JSON.parse(firstRefData)
      logger('Parsed attribution data:', parsed)
      // UTM data is stored in `data` object with prefix stripped (e.g., utm_source -> source)
      const data = parsed?.data || {}
      const utmParams = {
        utm_campaign: data.campaign,
        utm_source: data.source,
        utm_medium: data.medium,
        utm_content: data.content,
        utm_term: data.term,
      }
      logger('Extracted UTM params for Pendo:', utmParams)
      return utmParams
    }
    logger('No stored attribution data found')
  } catch (e) {
    console.error('Error reading stored UTM params:', e)
  }
  return {}
}
